"use strict";

exports.__esModule = true;
exports.default = void 0;

var _InboxIcon = _interopRequireDefault(require("../icons/InboxIcon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = {
  icon: _InboxIcon.default,
  version: "1.5",
  createdAt: "2015-12-21",
  updatedAt: "2017-12-21",
  appId: "inbox",
  layout: "finder",
  theme: {
    primaryColor: "#fff"
  },
  root: "/inbox",
  title: "Innboks",
  search: {
    placeholder: "Søk i innboks"
  },
  button: {
    title: "Create",
    url: "/inbox/new",
    action: "editor",
    children: [{
      title: "Upload",
      url: "/inbox/upload",
      action: "upload"
    }]
  },
  menu: [{
    "title": "Innboks",
    "path": ""
  }, {
    "title": "Apps",
    "path": "/app"
  }, {
    "title": "Eiere",
    "path": "/owner"
  }]
};
exports.default = _default;
module.exports = exports.default;